const roles = [
    {'value': 'admin', 'label': 'Admin'},
    {'value': 'user', 'label': 'User'},
]

export default roles